import { lazy } from 'react';

const list = lazy(() => import('./List'));
const show = lazy(() => import('./Show'));
const create = lazy(() => import('./Create'));

export { list, show, create };
